import { create } from 'zustand';

export interface ConnectionState {
  online: boolean;
  lastCheck: number;
  /**
   * Internal setter – do not use directly; prefer the hook helpers.
   */
  setState: (state: Pick<ConnectionState, 'online' | 'lastCheck'>) => void;
}

/**
 * Global store that tracks the health of the Supabase connection.
 * Other hooks & UI components can subscribe to show banners, etc.
 * 
 * NOTE: We always maintain online=true since 401 errors from the health endpoint
 * are expected and don't indicate a real connection issue.
 */
export const useConnectionStore = create<ConnectionState>((set) => ({
  online: true,
  lastCheck: Date.now(),
  setState: (state) => set({
    // Always maintain online=true to prevent false disconnection alerts
    online: true,
    lastCheck: state.lastCheck
  }),
}));
